const ariaOrDateRegex = /^(data|aria)-/i;

/**
 * Returns whether the specified prop name is an `aria-` or `data-` prop
 */
export const isAriaOrDataProp = (prop: string) => ariaOrDateRegex.test(prop);
